export const moduleSlug = "INITIAL_SCRAPE_TASK_BATCH_STARTS";

export default { moduleSlug };
